import { Box, Button, Link, Text } from "@chakra-ui/react";

import analyticsInstance from "../config/analytics";

export default function Contact() {
  return (
    <Box as="section" textAlign="center">
      <Text fontSize="4xl" pt="3em" pb="1em">
        ℹ️ Got any questions or comments?
      </Text>

      <Link href="/faq" fontSize="xl" mt="1em" onClick={() => analyticsInstance.track("FAQClicked")}>
        Check the FAQ
      </Link>

      <Text fontSize="xl" py="1em">
        or
      </Text>

      <Button
        as="a"
        colorScheme="blue"
        size="lg"
        href="mailto:help@btfdca.finance?subject=yo BTFDCA&body=<replace this with your message>"
        variant="outline"
        borderRadius="0"
        border="3px solid"
        py="2em"
        px="5em"
        onClick={() => analyticsInstance.track("ReachOutClicked")}
      >
        📧 Reach out to us!
      </Button>

      <Text fontSize="sm" pt="1em" pb="8em">
        We reply! 🫂
      </Text>
    </Box>
  );
}
